import React from 'react';
import {
    CloseIcon,
    Icon,
    SidebarContainer,
    SidebarLink,
    SidebarMenu,
    SidebarRouterLink,
    SidebarWrapper
} from "./SideBarElements";
import {FaFacebook, FaInstagram} from "react-icons/fa";
import logo from "../../images/ps_white_logo_small.png";

const Sidebar = ({isOpen, toggle}) => {
    return (
        <SidebarContainer isOpen={isOpen}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarRouterLink to='/' onClick={toggle}>
                        <img src={logo} alt="logo" />
                    </SidebarRouterLink>
                    <SidebarRouterLink to='/work' onClick={toggle}>
                        PROJECTS
                    </SidebarRouterLink>
                    <SidebarRouterLink to='/about' onClick={toggle}>
                        ABOUT
                    </SidebarRouterLink>
                    <SidebarRouterLink to='/contact' onClick={toggle}>
                        CONTACT
                    </SidebarRouterLink>
                    <SidebarLink href={'https://www.instagram.com/progress.studio.uk'} target="_blank" rel="noopener noreferrer" onClick={toggle}>
                        <FaInstagram size={35} />
                    </SidebarLink>
                    <SidebarLink href={'https://www.facebook.com/progress.studio.uk'} target="_blank" rel="noopener noreferrer" onClick={toggle}>
                        <FaFacebook size={35} />
                    </SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar;
